(function() {
    'use strict';

    var video = document.querySelector('.captions-edit__phone video');
    var mediaQuery;

    if (!video || !window.matchMedia) {
        return;
    }

    mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    var syncMotionPreference = function(query) {
        if (query.matches) {
            video.pause();
            video.removeAttribute('autoplay');
            return;
        }

        video.setAttribute('autoplay', 'autoplay');
        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(function() {});
        }
    };

    if (typeof mediaQuery.addEventListener === 'function') {
        mediaQuery.addEventListener('change', syncMotionPreference);
    } else if (typeof mediaQuery.addListener === 'function') {
        mediaQuery.addListener(syncMotionPreference);
    }

    syncMotionPreference(mediaQuery);
})();
